import { Grid } from '@material-ui/core';
import Layout from 'components/Layout';
import { useHttp } from 'hooks/http';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ListIcon, PencilIcon } from 'styles/icons';
import distanceDateTime from 'utils/distanceDateTime';
import { Button, WrapperLabel } from '../../../components/Forms';
import { ItemIcon } from '../../../components/CustomMenu';
import {
  Container, Content,
  WrapperMenu,
} from './styles';

interface ISocialAction {
  regiao: string;
  user: string;
  bairro: string;
  municipio: string;
  data_acao: string;
  created_at: string;
  server_time: string;
  action_status: boolean,
  attendance_count: number,
  details: Array<{
    partner_id: string;
    partner_name: string;
    service_id: string;
    service_name: string;
    quantity: number;
  }>;
}

const Detail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { httpGet, loading } = useHttp();
  const [socialAction, setSocialAction] = useState<ISocialAction | null>(null);
  const [serviceRows, setServiceRows] = useState([{
    partner: '', service: '', quantity: '', services: [],
  }]);

  useEffect(() => {
    async function loadActionDetails(): Promise<void> {
      const { status, data } = await httpGet(`/social-action/${id}`);
      if (status === 200) {
        setSocialAction(data);

        const rows = data.details.map((detail: any) => ({
          partner: detail.partner_name,
          service: detail.service_name,
          quantity: detail.quantity,
        }));

        setServiceRows(rows);
      }
    }

    loadActionDetails();
  }, [id, httpGet]);

  const breadcrumbs = {
    icon: ListIcon,
    links: [
      { path: '/', title: 'Ação Social' },
      { path: '', title: 'Detalhe da Ação Social' },
    ],
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>
          <WrapperMenu>  
            <div
              onClick={() => { history.push(`/social-action/edit/${id}`); }}
              style={{ width: 150, display: 'flex', alignItems: 'center', cursor: 'pointer',  justifyContent: 'center', }}
            >
              <ItemIcon icon={<PencilIcon  color='#FF0000' />} title="Editar" />
            </div>     
          </WrapperMenu>
        <Content>
          <Grid container spacing={1}>
            <WrapperLabel label="Criado por" xs={12} md={6} sm={6}>
              {socialAction?.user || 'N/A'}
            </WrapperLabel>

            <WrapperLabel label="Criado há" xs={12} md={6} sm={6}>
              {socialAction && socialAction.created_at && socialAction.server_time
                ? distanceDateTime(socialAction.created_at, socialAction.server_time, false)
                : 'Tempo não disponível'}
            </WrapperLabel>

          </Grid>
        </Content>

        <div style={{ marginTop: '1rem' }} />

        <Content>
          <Grid container spacing={1}>
            <WrapperLabel label="Data" xs={12} md={6} sm={6}>
              {socialAction?.data_acao ? formatDate(socialAction.data_acao) : 'Não cadastrado'}
            </WrapperLabel>

            <WrapperLabel label="Município" xs={12} md={6} sm={6}>
              {socialAction?.municipio || 'Não cadastrado'}
            </WrapperLabel>

            <WrapperLabel label="Região" xs={12} md={6} sm={6}>
              {socialAction?.regiao || 'Não cadastrado'}
            </WrapperLabel>

            <WrapperLabel label="Bairro" xs={12} md={6} sm={6}>
              {socialAction?.bairro || 'Não cadastrado'}
            </WrapperLabel>

            <WrapperLabel label="Público Presente" xs={12} md={6} sm={6}>
              {socialAction?.attendance_count || 'Não cadastrado'}
            </WrapperLabel>

            <WrapperLabel label="Status" xs={12} md={6} sm={6}>
              {socialAction?.action_status === true ? 'Ativada' : socialAction?.action_status === false ? 'Inativa' : 'Não cadastrado'}
            </WrapperLabel>

          </Grid>
        </Content>

        <div style={{ marginTop: '1rem' }} />

        <Content>
          <Grid container spacing={2}>
            {Object.entries(
              serviceRows.reduce((acc: Record<string, number>, item) => {
                const partnerName = item.partner || 'Parceiro não identificado';
                const quantity = Number(item.quantity) || 0;

                acc[partnerName] = (acc[partnerName] || 0) + quantity;
                return acc;
              }, {})
            ).reverse().map(([partnerName, total]) => (
              <React.Fragment key={partnerName}>
                <Grid item xs={12} sm={6} md={6}>
                  <WrapperLabel label="Parceiro">{partnerName}</WrapperLabel>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <WrapperLabel label="Total de Serviços">{total}</WrapperLabel>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </Content>

        <div style={{ marginTop: '1rem' }} />

        <Content>
          <Grid container spacing={2}>
            {[...serviceRows].reverse().map((row, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={4} md={4}>
                  <WrapperLabel label="Parceiro">
                    {row.partner || 'N/A'}
                  </WrapperLabel>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <WrapperLabel label="Serviço">
                    {row.service || 'N/A'}
                  </WrapperLabel>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <WrapperLabel label="Quantidade">
                    {row.quantity || 'N/A'}
                  </WrapperLabel>
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

          <Button type="button" onClick={() => { history.push('/social-action/list'); }}>
            Voltar
          </Button>
        </Content>
      </Container>
    </Layout>
  );
};

export default Detail;
